import React from 'react';

import PropTypes from 'prop-types';
import { Download } from '@tds/core-interactive-icon';
import Heading from '@tds/core-heading';
import DimpleDivider from '@tds/core-dimple-divider';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import request, { isOrderFulfillmentTeam } from '../../utils/request';
import Attachements from './attachements';

const OrderAttachments = ({ links, orderData }) => {
  const localizedString = useLocalizedStringsContext();
  const {
    ORDERS: { quotePdf, contractUnSigned, contractSignedPdf, attachments }
  } = localizedString;
  const profile = request.getProfile();
  const uploadAttachementAvailable =
    profile && [3, 5, 13].includes(profile.role_id);
  const isLinkAvailable =
    profile && [2, 3, 4, 5, 7, 8, 11].includes(profile.role_id);

  const getRow = (name, label) =>
    links[name] ? (
      <li
        className="list-group-item"
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <div>{label}</div>
        <div>
          <Download
            onClick={() => window.open(links[name], '_blank')}
            a11yText="Download"
          />
        </div>
      </li>
    ) : null;
  const linkSignedPdf =
    isLinkAvailable && getRow('contractSignedPdf', contractSignedPdf);

  return (
    <>
      <>
        <DimpleDivider />
        <Heading level="h2" tag="h4">
          {attachments}
        </Heading>
        <DimpleDivider />
        <div className="card">
          <div className="card-header">
            <Heading level="h4">Quote/Contract pdf</Heading>
          </div>
          <ul className="list-group list-group-flush">
            {getRow('quotePdf', quotePdf)}
            {isOrderFulfillmentTeam &&
              getRow('contractUnSigned', contractUnSigned)}
            {linkSignedPdf && linkSignedPdf}
          </ul>
        </div>
        <Attachements
          isUploadAvailable={uploadAttachementAvailable}
          orderData={orderData}
        />
      </>
    </>
  );
};

OrderAttachments.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.any).isRequired,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      quotePdf: PropTypes.string,
      contractUnSigned: PropTypes.string,
      contractSignedPdf: PropTypes.string
    })
  ).isRequired
};

export default OrderAttachments;
